
import { Pipe, PipeTransform } from '@angular/core';

//mettre en majiscule la premier lettre

@Pipe({
  name: 'capitalizefirst'
})
export class CapitalizeFirstPipe implements PipeTransform {
  transform(value: string, args: any[]): string {
    if (value === null) {
      return 'Not assigned';
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
